const appConfig = {
  apiRoot: window.apiPrefix,
  apiPrefix: '/api',
  reportUrl: window.reportUrl,
  authenticatedEntryPath: '/app/inventory/catalog',
  unAuthenticatedEntryPath: '/sign-in',
  tourPath: '/app/account/kyc-form',
  locale: 'en',
  enableMock: true,
  currency: window.currency,
  S3: window.S3,
  storage: window.storage,
  _version: '26.8.1'
}

export default appConfig
